import { useRef, useState, useCallback } from 'react';

// Right-click == kebab wiring for rows that render a TrackContextMenu or
// MixContextMenu. One hook instance per list-hosting component; `key`
// disambiguates rows (use the same string as the row's React key).
//
//   const { openRowCtx, rowCtxFor } = useRowContextMenu();
//   <div onContextMenu={openRowCtx(`played-${i}`)} ...>
//       <TrackContextMenu track={track} openAtPoint={rowCtxFor(`played-${i}`)} />
//
// The menu components own the actual open/position logic via their
// `openAtPoint` prop ({ x, y, nonce }); the nonce bump per contextmenu event
// is what lets a repeat right-click at the same spot re-open the menu.
// Tabs with multi-select route through useRowSelection's bulk handling
// instead (see CuePointsTab) — this hook is for single-row surfaces.
export default function useRowContextMenu() {
    const nonceRef = useRef(0);
    const [rowCtx, setRowCtx] = useState(null); // { key, x, y, nonce }

    const openRowCtx = useCallback((key) => (e) => {
        e.preventDefault();
        e.stopPropagation();
        setRowCtx({ key, x: e.clientX, y: e.clientY, nonce: ++nonceRef.current });
    }, []);

    const rowCtxFor = useCallback((key) => (rowCtx && rowCtx.key === key ? rowCtx : null), [rowCtx]);

    return { openRowCtx, rowCtxFor };
}
